<template>
  <div class="mctitle">
    <div
      class="mc_top"
      style="
        margin: 0;
        margin-top: -38px;
        display: flex;
        align-items: center;
        height: 54px;
        border-bottom: 0;
        margin-right: 52px;
      "
    >
      <div class="left">
        <p class="p2">{{ title }}</p>
      </div>
      <div class="rightbtn">
        <el-button
          @click="refresh"
          size="small"
          icon="iconfont icon-shuaxin1"
          :disabled="$parent.$parent.loading"
          >刷新</el-button
        >
        <el-button @click="exportList" size="small" icon="iconfont icon-daochu"
          >导出</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "dialogHeader",
  props: ["title"],

  methods: {
    refresh() {
      this.$emit("refresh");
    },
    exportList() {
      this.$emit("exportList");
    },
  },
};
</script>

<style lang="scss" scoped>
.mctitle {
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3b3946;
  background: #ffffff;
  border-radius: 4px;
}

.mc_top {
  margin: 0 24px;
  margin-top: 16px;
  display: flex;
  align-items: center;
  height: 54px;
  border-bottom: 1px solid #f0eef3;

  .left {
    display: flex;
    align-items: center;
  }

  .p1 {
    width: 4px;
    height: 16px;
    background: #5a2df5;
    border-radius: 1px;
    margin-right: 8px;
  }

  .p2 {
    color: #3b3946;
  }

  .rightbtn {
    display: flex;
    margin-left: auto;

    ul {
      cursor: pointer;
      width: 68px;
      height: 28px;
      background: rgba(255, 255, 255, 0);
      border-radius: 4px;
      border: 1px solid #5a2df5;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #5a2df5;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-left: 14px;

      img {
        width: 16px;
        height: 16px;
      }
    }
  }
}

::v-deep( .el-button) {
  width: 68px;
  height: 28px;
  border-color: #5a2df5;
  color: #5a2df5;
}

::v-deep( .iconfont) {
  margin-right: 4px;
}
</style>
